import { render, staticRenderFns } from "./ProductView.vue?vue&type=template&id=ac71ec3a&scoped=true"
import script from "./ProductView.vue?vue&type=script&lang=ts"
export * from "./ProductView.vue?vue&type=script&lang=ts"
import style0 from "./ProductView.vue?vue&type=style&index=0&id=ac71ec3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac71ec3a",
  null
  
)

export default component.exports